module.exports = new __parcel__URL__("error-state.90c920b0.svg").toString();